module.exports = __webpack_public_path__ + "img/banner-13.e1d5ec69.jpg";